import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';

import { ImageSelector } from '../../../../util/imageSelector/imageSelector';

@Component({
  selector: 'page-slide',
  templateUrl: 'slide.html',
  providers : [HttpClient, CustomToast]
})
export class SlidePage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  baseUrl;

  image = {
    id : -1,
    filename : 'addimage.png'
  };

  slide = {
    id : -1,
    position : 1,
    image : '',
    title_es : '',
    title_en : '',
    text_es : '',
    text_en : '',
    button_es : '',
    button_en : '',
    url : ''
  };

  positions = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20];

  customToast : CustomToast;
  events : Events;
  alertCtrl : AlertController;

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events, alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();
    
    this.customToast = customToast;
    this.events = events;
    this.alertCtrl = alertCtrl;
    let id = this.navParams.get('id');
    this.httpCallSlide(id);
	}

  onClickImage(){
    let modal = this.modalCtrl.create(ImageSelector);
    modal.present();
    modal.onDidDismiss(image => {
      if(image){
        this.image = image;
        this.slide.image = image.filename;
      }
    });
  }

  httpCallSlide(id){
    this.httpClient.get('/slides/'+id, (error,data)=>{
      this.slide = data.json();
      this.image.filename = this.slide.image;
    });
  }

  httpUpdateSlide(){
    this.httpClient.put('/slides',this.slide,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Slide actualizado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('slide:update');
      }
    });
  }

  onClickSave(){
    this.httpUpdateSlide();
  }

  onClickDelete(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a eliminar este slide',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.httpCallDelete();
          }
        }
      ]
    });
    alert.present();
  }

  httpCallDelete(){
    this.httpClient.delete('/slides/'+this.slide.id,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Slide eliminado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('slide:delete');
      }
    });
  }



}



// WEBPACK FOOTER //
// ./src/pages/dashboard/slides/slide/slide.ts